import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import store from "@/store";
import Service from "@/services/AuditKeslingService";
import { AuditKeslingSession } from "@/types/audit_kesling";

@Module({
  store,
  dynamic: true,
  namespaced: true,
  name: "audit-kesling"
})
class AuditKeslingModule extends VuexModule {
  sessions: AuditKeslingSession[] = [];
  currentSession: AuditKeslingSession | null = null;
  loading = false;
  pagination = {
    currentPage: 1,
    lastPage: 1,
    perPage: 20,
    total: 0
  };
  filters = {
    tgl_dari: "" as string,
    tgl_sampai: "" as string,
    unit_id: "" as string,
    status: "" as string,
    kategori_kepatuhan: "" as string,
    search: "" as string
  };

  @Mutation SET_SESSIONS(val: AuditKeslingSession[]) { this.sessions = val; }
  @Mutation SET_CURRENT(val: AuditKeslingSession | null) { this.currentSession = val; }
  @Mutation SET_LOADING(val: boolean) { this.loading = val; }
  @Mutation SET_PAGINATION(val: any) { this.pagination = val; }
  @Mutation SET_FILTERS(val: any) { this.filters = { ...this.filters, ...val }; }

  @Action
  async loadSessions(params?: any) {
    this.SET_LOADING(true);
    try {
      const dt = await Service.getList({ ...this.filters, ...params });
      const resp = dt.data.data;
      this.SET_SESSIONS(resp.data || []);
      this.SET_PAGINATION({
        currentPage: resp.current_page,
        lastPage: resp.last_page,
        perPage: resp.per_page,
        total: resp.total
      });
    } catch (e) {
      console.error("loadSessions error:", e);
    }
    this.SET_LOADING(false);
  }

  @Action
  async loadSession(id: number) {
    this.SET_LOADING(true);
    try {
      const dt = await Service.find(id);
      this.SET_CURRENT(dt.data.data || null);
      return dt.data.data;
    } catch (e) {
      console.error("loadSession error:", e);
    } finally {
      this.SET_LOADING(false);
    }
  }

  @Action
  async createSession(data: any) {
    const dt = await Service.create(data);
    this.SET_CURRENT(dt.data.data || null);
    return dt.data.data;
  }

  @Action
  async updateSession(payload: { id: number; data: any }) {
    const dt = await Service.update(payload.id, payload.data);
    this.SET_CURRENT(dt.data.data || null);
    return dt.data.data;
  }

  @Action
  async deleteSession(id: number) {
    await Service.destroy(id);
  }

  @Action
  async saveItemsBulk(payload: { id: number; items: any[] }) {
    const dt = await Service.updateItemsBulk(payload.id, payload.items);
    this.SET_CURRENT(dt.data.data || null);
    return dt.data.data;
  }

  @Action
  async sign(payload: { id: number; role: "auditor" | "petugas_jaga"; password: string }) {
    const method = payload.role === "auditor"
      ? Service.submitAuditor
      : Service.acknowledgePetugasJaga;
    const dt = await method(payload.id, { password: payload.password });
    await this.loadSession(payload.id);
    return dt.data;
  }

  @Action
  setFilters(filters: any) {
    this.SET_FILTERS(filters);
  }
}

export default getModule(AuditKeslingModule);
